import cx from 'classnames'

import Image from 'next/image'
import { Href } from 'components/navigation'

type LogoProps = {
  className?: string
  isSecondary?: boolean
}

const Logo: React.FC<LogoProps> = props => {
  const { className, isSecondary } = props

  const imageSrc = isSecondary
    ? '/images/secondary_logo.webp'
    : '/images/logo.webp'

  return (
    <Href to="/" className={cx('flex items-center', className)}>
      <Image src={imageSrc} alt="Logo" width={71} height={16} />
    </Href>
  )
}

export default Logo
